import React from "react";
import { Link } from "react-router-dom";

function Utilities() {
  return (
    <div className="min-h-screen bg-white">
      <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-amber-50/50 to-orange-50/40 pt-40 pb-24">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-amber-200/40 via-transparent to-transparent" />
        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center lg:px-8">
          <div className="mb-8 inline-flex items-center rounded-full border border-amber-200 bg-amber-100 px-4 py-2 text-sm font-medium text-amber-800">
            Utilities
          </div>
          <h1 className="mb-6 text-5xl font-bold text-slate-900 md:text-6xl">
            Utility planning is
            <span className="block bg-gradient-to-r from-amber-500 to-orange-500 bg-clip-text text-transparent">coming soon</span>
          </h1>
          <p className="mx-auto mb-10 max-w-2xl text-lg leading-relaxed text-slate-600">
            We&apos;re preparing a dedicated page for utilities with more details on grid planning, load forecasting, and EV demand insights.
          </p>
          <div className="flex flex-col justify-center gap-4 sm:flex-row">
            <Link
              to="/#solutions"
              className="inline-flex items-center justify-center rounded-lg bg-slate-900 px-8 py-4 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
            >
              Back to Solutions
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-lg border border-slate-300 px-8 py-4 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-100"
            >
              Contact Sales
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Utilities;